import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "page-title" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Preciso Assinar")
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Documentos Assinados")
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Documentos Cancelados")
const _hoisted_8 = { key: 3 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Outras assinaturas pendentes")
const _hoisted_10 = { key: 4 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileTextOutlined = _resolveComponent("FileTextOutlined")!
  const _component_LockOutlined = _resolveComponent("LockOutlined")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_ctx.currentStatus == 1)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createVNode(_component_FileTextOutlined, { class: "ic-files" }),
          _hoisted_3
        ]))
      : (_ctx.currentStatus == 2)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _createVNode(_component_FileTextOutlined, { class: "ic-files" }),
            _hoisted_5
          ]))
        : (_ctx.currentStatus == 3)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
              _createVNode(_component_FileTextOutlined, { class: "ic-files" }),
              _hoisted_7
            ]))
          : (_ctx.currentStatus == 6)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                _createVNode(_component_FileTextOutlined, { class: "ic-files" }),
                _hoisted_9
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_10, [
                _createVNode(_component_LockOutlined, { class: "ic-files" }),
                _createTextVNode(" " + _toDisplayString(_ctx.folderName), 1)
              ])),
    _hoisted_11
  ]))
}